import { render } from "./directorForm.vue?vue&type=template&id=072aa433&scoped=true"
import script from "./directorForm.vue?vue&type=script&lang=js"
export * from "./directorForm.vue?vue&type=script&lang=js"

import "./directorForm.vue?vue&type=style&index=0&id=072aa433&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072aa433"]])

export default __exports__